import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';

const styleSheet = (theme) => ({
  checkBox: {
    marginTop: 0,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
  },
  error: {
    color: '#FF0050',
    marginTop: 0,
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
  }
});

class CustomCheckbox extends Component{
  constructor(props) {
    super(props);
  }

  renderError = () => {
    if (this.props.error) {
      return (<span className={this.props.classes.error}>{this.props.error}</span>);
    }
    return null;
  }

  render() {
    const { value, classes, checked } = this.props;
    return (
      <div>
        <FormControlLabel
          control={
            <Checkbox
              className={classes.checkBox}
              checked={checked}
              onChange={this.props.onChange}
              value={value}
            />
          }
          label={`
            I/We grant our irrevocable permission to release our confidential information to Amazy Investment Pty Ltd and/or its affiliated companies.
            I/We understand this information is being used for their credit and underwriting purposes only.`}
        />
        { this.renderError() }
      </div>
    );
  }
}

CustomCheckbox.propTypes = {
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.string
};

CustomCheckbox.defaultProps = {
  checked: false,
  error: null
}

export default withStyles(styleSheet)(CustomCheckbox);


// WEBPACK FOOTER //
// ./src/components/FormComponents/Checkbox/index.js